import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useVehicles } from "../../Context/VehiclesContext";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";

const useStyles = makeStyles(style);

const Vehicle = () => {
  const classes = useStyles();
  const { selected, setSelected, doSave, vehicleTypes } = useVehicles();

  const [form, setForm] = useState({
    id: "",
    plateNumber: "",
    vehicleTypeId: 0,
    error: { plateNumber: "", vehicleTypeId: "" }
  });

  useEffect(() => {
    if (selected) {
      setForm({
        id: selected.vehicleId,
        plateNumber: selected.plateNumber || "",
        vehicleTypeId: selected.vehicleTypeId || 0,
        error: { plateNumber: "", vehicleTypeId: "" }
      });
    }
  }, [selected]);

  const saveUpdate = async (form) => {
    let newError = { plateNumber: "", vehicleTypeId: "" };

    if (form.plateNumber === "") {
      newError.plateNumber = "*Completar el campo";
    }

    if (form.vehicleTypeId === 0) {
      newError.vehicleTypeId = "*Selecciona una opción";
    }

    setForm({ ...form, error: newError });

    if (form.plateNumber !== "" && form.vehicleTypeId !== 0) {
      const data = {
        id: form.id || null,
        plateNumber: form.plateNumber,
        vehicleTypeId: form.vehicleTypeId
      };

      const result = await doSave(data);
      if (result.success) {
        handleCancel();
      } else {
        const errorMessage = result.error && result.error[0].details.field === "plateNumber"
          ? "*La matrícula ya existe"
          : result.error[0].details.errorMessages[0] || "Error al guardar";
        
        setForm({ ...form, error: { ...newError, messageSave: errorMessage } });
      }
    }
  };

  const handleCancel = () => {
    setForm({
      id: "",
      plateNumber: "",
      vehicleTypeId: 0,
      error: { plateNumber: "", vehicleTypeId: "" }
    });
    setSelected(null);
  };

  return (
    <div className={classes.contentForm}>
      <Grid container>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>ID </label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  disabled
                  name="id"
                  value={form.id}
                  variant="outlined"
                  className={classes.textFielInput + " blocked-id"}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Matrícula</label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="plateNumber"
                  value={form.plateNumber}
                  variant="outlined"
                  inputProps={{
                    maxLength: 7
                  }}
                  onChange={(e) => setForm({ ...form, plateNumber: e.target.value })}
                  className={classes.textFielInput}
                />
                <p>
                  {form.error.plateNumber === ""
                    ? form.error.messageSave !== undefined
                      ? form.error.messageSave
                      : null
                    : form.error.plateNumber}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Tipo Vehículo</label>
              </Grid>
              <Grid item xs={9}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    name="vehicleTypeId"
                    value={form.vehicleTypeId}
                    onChange={(e) => setForm({ ...form, vehicleTypeId: e.target.value })}
                  >
                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                    {vehicleTypes.map(res => {
                      return (
                        <MenuItem key={res.vehicleTypeId} value={res.vehicleTypeId}>
                          {res.vehicleTypeDescription}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <p>
                  {form.error.vehicleTypeId === undefined
                    ? ""
                    : form.error.vehicleTypeId}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <div className={classes.contentButton}>
        <button onClick={handleCancel}>Cancelar</button>
        <button onClick={() => saveUpdate(form)}>Guardar</button>
      </div>
    </div>
  );
};
export default Vehicle;
